import { getRouterSelectors } from '@ngrx/router-store';

export const {
    selectCurrentRoute, // select the current route
    selectRouteParams, // select the current route params
    selectRouteData
} = getRouterSelectors();
